export const image = {
  link: "https://res.cloudinary.com/df3ajcohw/image/upload/v1636427773/assets/d7awuo2gpbyrkmdjfxtc.jpg",
  alt: "TraStar Headquarters",
};
